var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import styled from 'styled-components';
import Position from './interfaces/position';
import ReactDOM from 'react-dom';
import useDebounce from 'pathfinder/utils/useDebounce';
import { BackDrop } from './BackDrop';
import { Tooltip } from './Tooltip';
import { Pointer } from './Pointer';
import ThemeProvider from '../Theme/ThemeProvider';
import RenderOnPortal from '../RenderOnPortal';
import waitForElement from 'pathfinder/modules/HighlightToAction/utils/waitForElement';
import waitForEvent from 'utils/waitForEvent';
import log from 'pathfinder/utils/log';
import isInViewPort from './utils/isInViewPort';
import { addCoachMarkImpression, getCoachMarkWasShownBefore } from './tracking';
import useResizeObserver from './utils/useResizeObserver';
var StyledCoachMarkContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tcolor: white;\n\tposition: relative;\n\twidth: fit-content;\n\ttransition: all ease-in 1s;\n"], ["\n\tcolor: white;\n\tposition: relative;\n\twidth: fit-content;\n\ttransition: all ease-in 1s;\n"])));
var coachMarkThemeProps = {
    dark: {
        coachMark: {
            tooltipBorderColor: 'rgba(89,83,88,1.0)',
            textColor: 'white',
            toolTipBackground: 'rgba(30, 12, 27, 1)',
            arrowBorderColor: 'rgba(30,12,27,1.0)',
            closeButtonColor: 'rgba(255, 197, 0, 1)',
        },
    },
    light: {
        coachMark: {
            tooltipBorderColor: 'rgba(214,208,213,1.0)',
            textColor: 'rgba(58,58,58,1.0)',
            toolTipBackground: 'rgba(255,255,255,1.0)',
            arrowBorderColor: 'white',
            closeButtonColor: 'rgba(82,0,68,1.0)',
        },
    },
    shared: {
        coachMark: {
            zIndex: 500,
        },
    },
};
export var CoachMark = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var _g = React.useState(false), isClosed = _g[0], setIsClosed = _g[1];
    var onClose = function () {
        props.onClose && props.onClose();
        setIsClosed(function (closed) { return !closed; });
    };
    if (isClosed) {
        return (_a = props.children) !== null && _a !== void 0 ? _a : React.createElement(React.Fragment, null);
    }
    if (props.withBackdrop && ((_b = coachMarkThemeProps === null || coachMarkThemeProps === void 0 ? void 0 : coachMarkThemeProps.shared) === null || _b === void 0 ? void 0 : _b.coachMark) != null) {
        coachMarkThemeProps.shared.coachMark.zIndex = (_c = props.zIndex) !== null && _c !== void 0 ? _c : 800;
    }
    else if (props.zIndex) {
        coachMarkThemeProps.shared.coachMark.zIndex = (_d = props.zIndex) !== null && _d !== void 0 ? _d : coachMarkThemeProps.shared.coachMark.zIndex;
    }
    if (props.withBackdrop) {
        coachMarkThemeProps.shared.coachMark.backdropZindex = (_f = (_e = props.zIndexBackdrop) !== null && _e !== void 0 ? _e : props.zIndex) !== null && _f !== void 0 ? _f : 800;
    }
    // This is being set somewhere I cannot track down
    coachMarkThemeProps.light.coachMark.zIndex = undefined;
    return (React.createElement(ThemeProvider, { isDark: props.dark, values: coachMarkThemeProps },
        React.createElement(FixedCoachMark, __assign({}, props, { onClose: onClose }))));
};
var FixedCoachMark = function (_a) {
    var _b = _a.position, position = _b === void 0 ? Position.bottom : _b, _c = _a.showPointer, showPointer = _c === void 0 ? true : _c, children = _a.children, _d = _a.pointerDistance, pointerDistance = _d === void 0 ? 0 : _d, toolTipText = _a.toolTipText, onGetPosition = _a.onGetFixedPosition, _e = _a.withBackdrop, withBackdrop = _e === void 0 ? false : _e, onClose = _a.onClose, onTryItClick = _a.onTryItClick, domTargetElement = _a.domTargetElement, domRootElement = _a.domRootElement, userOriginalPosition = _a.userOriginalPosition, _f = _a.tooltipWidth, tooltipWidth = _f === void 0 ? 265 : _f, _g = _a.withoutClose, withoutClose = _g === void 0 ? false : _g, onClick = _a.onClick;
    var targetElement = React.useRef(domTargetElement());
    var tooltipRef = React.useRef(null);
    var _h = React.useState({
        top: 0,
        left: 0,
    }), positionProps = _h[0], setPositionProps = _h[1];
    var _j = React.useState(false), initialCalculation = _j[0], setinitialCalculation = _j[1];
    var calculatePositioning = useDebounce(function (initialCalculation) {
        if (targetElement && targetElement.current) {
            var boundingRect = targetElement.current.getBoundingClientRect();
            var tooltipBoundRect = tooltipRef.current.getBoundingClientRect();
            var xPosition = boundingRect.left;
            var yPosition = boundingRect.top;
            if (position == Position.bottom) {
                yPosition += targetElement.current.clientHeight;
                yPosition += pointerDistance;
            }
            if (position == Position.top) {
                yPosition -= tooltipBoundRect.height;
                yPosition -= pointerDistance;
            }
            if (position == Position.top || position == Position.bottom || position == Position.verticalCenter) {
                xPosition += targetElement.current.clientWidth / 2;
                xPosition -= tooltipRef.current.clientWidth / 2;
            }
            if (position == Position.verticalCenter) {
                yPosition += targetElement.current.clientHeight / 2;
                yPosition += pointerDistance;
            }
            if (position == Position.right) {
                xPosition += targetElement.current.clientWidth;
                xPosition += pointerDistance;
            }
            if (position == Position.left) {
                xPosition -= tooltipRef.current.clientWidth;
                xPosition -= pointerDistance;
            }
            if (position == Position.right || position == Position.left) {
                yPosition += targetElement.current.clientHeight / 2;
                yPosition -= tooltipRef.current.clientHeight / 2;
            }
            var resultPosition = {
                top: yPosition,
                left: xPosition,
            };
            if (onGetPosition != null) {
                resultPosition = onGetPosition(resultPosition, tooltipRef.current, targetElement.current);
            }
            setPositionProps(resultPosition);
            if (!initialCalculation) {
                setinitialCalculation(true);
            }
        }
    }, 10);
    React.useEffect(function () {
        if (targetElement.current) {
            var recalculateListener_1 = function () { return calculatePositioning(initialCalculation); };
            window.addEventListener('resize', recalculateListener_1);
            window.addEventListener('scroll', recalculateListener_1);
            calculatePositioning(initialCalculation);
            return function cleanup() {
                window.removeEventListener('resize', recalculateListener_1);
                window.removeEventListener('scroll', recalculateListener_1);
            };
        }
    }, [targetElement]);
    useResizeObserver(function () {
        calculatePositioning(initialCalculation);
    }, document.documentElement);
    var onToolTipClick = function (scrollUserBack) {
        if (withBackdrop) {
            document.body.style.overflow = 'initial';
        }
        if (scrollUserBack) {
            document.documentElement.scrollTop = userOriginalPosition.top;
            document.documentElement.scrollLeft = userOriginalPosition.left;
        }
        onClose();
    };
    var tryItClickWithClose = function (scrollUserBack) {
        onTryItClick && onTryItClick();
        onToolTipClick(scrollUserBack);
    };
    React.useEffect(function () {
        if (withBackdrop) {
            document.body.style.overflow = 'hidden';
        }
        return function () {
            if (withBackdrop) {
                document.body.style.overflow = 'initial';
            }
        };
    }, []);
    return (React.createElement(StyledCoachMarkContainer, { "data-testid": "coach-mark-component", style: { opacity: initialCalculation ? 1 : 0 }, onClick: onClick },
        !domTargetElement && React.createElement("div", { ref: targetElement }, children),
        React.createElement(RenderOnPortal, { root: domRootElement },
            withBackdrop && React.createElement(BackDrop, { onClick: function () { return onToolTipClick(true); } }),
            React.createElement(Tooltip, { position: position, positionCss: positionProps, tooltipRef: tooltipRef, text: toolTipText, onClick: onToolTipClick, onTryItClick: tryItClickWithClose, style: { opacity: initialCalculation ? 1 : 0 }, withBackDrop: withBackdrop, width: tooltipWidth, withoutClose: withoutClose }, showPointer && React.createElement(Pointer, { position: position })))));
};
export var renderCoachMark = function (domTargetElement, options, scrollTarget) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, forced, _b, automaticScroll, trackName, callback, props, container_1, _c, element, documentReady, userOriginalPosition, elementProps, err_1;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 7, , 8]);
                _a = options.forced, forced = _a === void 0 ? false : _a, _b = options.automaticScroll, automaticScroll = _b === void 0 ? true : _b, trackName = options.trackName, callback = options.callback, props = options.componentProps;
                container_1 = options.container;
                _c = !forced;
                if (!_c) return [3 /*break*/, 2];
                return [4 /*yield*/, getCoachMarkWasShownBefore(trackName)];
            case 1:
                _c = (_d.sent());
                _d.label = 2;
            case 2:
                if (_c) {
                    return [2 /*return*/];
                }
                if (props.withBackdrop) {
                    document.body.style.overflow = 'hidden';
                }
                return [4 /*yield*/, waitForElement(function () { return domTargetElement(); })];
            case 3:
                element = (_d.sent());
                return [4 /*yield*/, waitForEvent({
                        eventCheck: function () { return document.readyState == 'complete'; },
                        maxWaitTime: 10000,
                        intervalTime: 500,
                        onResolve: function () { return true; },
                        onReject: function () { return false; },
                    })()];
            case 4:
                documentReady = _d.sent();
                if (!documentReady) {
                    log.error('document ready timeout');
                    return [2 /*return*/];
                }
                userOriginalPosition = {
                    top: document.documentElement.scrollTop,
                    left: document.documentElement.scrollLeft,
                };
                if (!(props.withBackdrop && automaticScroll)) return [3 /*break*/, 6];
                return [4 /*yield*/, scrollUntilElementIsInView(scrollTarget !== null && scrollTarget !== void 0 ? scrollTarget : element)];
            case 5:
                _d.sent();
                _d.label = 6;
            case 6:
                if (!container_1) {
                    container_1 = document.createElement('div');
                    document.body.appendChild(container_1);
                }
                elementProps = __assign(__assign({}, props), { domTargetElement: domTargetElement, userOriginalPosition: userOriginalPosition });
                ReactDOM.render(React.createElement(CoachMark, __assign({}, elementProps)), container_1, callback);
                if (trackName) {
                    addCoachMarkImpression(trackName);
                }
                return [2 /*return*/, function () {
                        return ReactDOM.unmountComponentAtNode(container_1);
                    }];
            case 7:
                err_1 = _d.sent();
                log.error(err_1);
                document.body.style.overflow = 'initial';
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}); };
var scrollUntilElementIsInView = function (element) {
    var isScrolling = false;
    var scrollTimeout;
    var scrollListener = function () {
        isScrolling = true;
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
            isScrolling = false;
        }, 500);
    };
    window.addEventListener('scroll', scrollListener);
    var onEnd = function () {
        window.removeEventListener('scroll', scrollListener);
    };
    return waitForEvent({
        eventCheck: function () {
            if (!isInViewPort(element) && !isScrolling) {
                element.scrollIntoView({
                    block: 'center',
                    inline: 'center',
                    behavior: 'smooth',
                });
            }
            return isInViewPort(element) && !isScrolling;
        },
        intervalTime: 500,
        maxWaitTime: 10000,
        onReject: onEnd,
        onResolve: onEnd,
    })();
};
var templateObject_1;
